export type AbPattern = 'A' | 'B' | 'C' | 'D'

export interface PatternConfig {
    pattern: AbPattern
    percentage: number
}

export interface AbTestConfig {
    issueNumber: string
    patterns: PatternConfig[]
    pathRegex: RegExp
    isActive: boolean
}

export const DEFAULT_PATTERN: AbPattern = 'A'


